angular.module('SpidApp')

.factory('VacationService',
	    ['Restangular', '_', 'Vacation', 'ConfigService', 
function (Restangular,   _,   Vacation,   ConfigService) {
	var VacationService = {
		all: function () {
			return Restangular.all("vacations").getList().then(function (vacationsData) {
				return _.map(vacationsData, function (vacationData) {
					return new Vacation(vacationData)
				})
			})
		},

		find: function (agencyId, id) {
			if (id === undefined || id === null) {
				throw 'VacationService::find() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).one('vacations', id).get().then(function (vacationData) {
				return new Vacation(vacationData)
			})
		},
		
		findByAgencyId: function (agencyId, options) {
			options = options || {}
			
			if (agencyId === undefined || agencyId === null) {
				throw 'VacationService::findByAgencyId() - Missing parameters'
			}

			return Restangular.one('agencies', agencyId).all('vacations').getList().then(function (vacationsData) {
				if (options.filter) {
					if (options.filter.date) {
						vacationsData = _.filter(vacationsData, function (vacationData) {
							return vacationData.date_start.substr(0, 10) === options.filter.date
						})
					}
					if (options.filter.last && vacationsData) {
						vacationsData = vacationsData.slice(-1);
					}
				}
				
				return _.map(vacationsData, function(vacationData){
					return new Vacation(vacationData)
				})
			})
		},

		findByIdUser: function (idUser, options) {
			options = options || false

			if (!idUser) {
				throw 'VacationService::findByIdUser() - Missing parameters'
			}

			return Restangular.one('users', idUser).all('vacations').getList().then(function (vacationsData) {
				if (options.isOnGoing) {
					vacationsData = _.filter(vacationsData, function (vacationData) {
						return !vacationData.end_state_id
					})
				}
				
				return _.map(vacationsData, function(vacationData){
					return new Vacation(vacationData)
				})
			})
		},
		
		create: function(idUser, v) {
			if (!idUser || !v) {
				throw 'VacationService::create() - Missing parameters'
			}
			
			return ConfigService.all().then(function(memo) {
				return memo.agencyId
			}).then(function(agencyId) {
				var vacation           = new Vacation()
				vacation.idUser        = idUser
				vacation.idAgency      = agencyId
				vacation.amountStart   = +v.amountStart
				vacation.startTransfer = +v.startTransfer
				vacation.comment 	   = v.comment || null
				vacation.validationComment = v.validation_comment || null
				
				return Restangular.all('vacations').post(vacation)
			})	
		},
		
		close: function(id, v) {
			if (!v) {
				throw 'VacationService::close() - Missing parameters'
			}
			
			var vacation = new Vacation()
			vacation.id           = id
			vacation.amountEnd    = v.amountEnd
			vacation.stopTransfer = v.stopTransfer
			
			var request = Restangular.one("vacations", id)
			return request.customPOST(vacation, null, {}, {})
		},

		save: function (vacation) {
			if (!vacation) {
				throw 'VacationService::save() - Missing parameters'
			}

			return Restangular.one('vacations', vacation.id).post(null, vacation)
		},
		
		allActive : function(){
			return VacationService.all("include=['users']").then(function(data){
				var aVacations = [];
				for(var key in data){
					if(data[key].dateEnd !== null){
						continue;
					}
					data[key].vacationOngoing = moment(data[key].dateStart).calendar();
					aVacations.push(data[key]);
				}
				return aVacations;
			})
		}
	}

	return VacationService
}])
